module.exports = __webpack_public_path__ + "img/catB.a3f7af28.svg";